<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap">
        <a-form-model layout="inline" :model="searchForm.data">
          <a-form-model-item :label="$t('LOOK_BOOK_TOPIC') || '主题'">
            <a-select style="width: 174px;" v-model="searchForm.data.topicId" allowClear>
              <a-select-option :key="item.id" :value="item.id" v-for="item in topic.data">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :label="$t('NAME') || '名称'">
            <a-input v-model="searchForm.data.name" allowClear/>
          </a-form-model-item>
          <a-form-model-item>
            <a-button
                type="primary"
                plain
                icon="el-icon-search"
                      @click="getLookBookList">{{ $t('SEARCH') || '查询' }}
            </a-button>
          </a-form-model-item>
        </a-form-model>
        <a-button type="primary" @click="addLookBook">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>

      <a-row :gutter="20" style="margin-top:50px;">
        <a-col
          :span="4"
          v-for="item in table.data"
          :key="item.id">
          <a-card
            style="margin-bottom: 20px"
            hoverable>
           <img
             slot="cover"
             alt="example"
             class="cover-img"
             :src="item.coverPath"
           />
            <template slot="actions" class="ant-card-actions">
              <a-icon type="edit" @click="editLookBook(item.id)"/>
              <a-icon type="eye"  @click="lookBookDetail(item.id)"/>
              <a-icon type="left" @click="upLookBook(item.id)"/>
              <a-icon type="right" @click="downLookBook(item.id)"/>
                <a-icon type="close" @click="deleteLookBook(item.id)"/>
            </template>
            <a-card-meta :title="item.name">
            </a-card-meta>
          </a-card>
        </a-col>
      </a-row>
        <a-pagination
                class ="pagination-class"
                  v-model="table.query.page"
                    :total="table.query.total"
                    show-size-changer
                    :page-size="table.query.size"
                    :pageSizeOptions="['5','20','50','100']"
                    @showSizeChange="handleSizeChange"
                    @change="handleSizeChange">
                    <template
                  slot="buildOptionText"
                  slot-scope="props">
          <span>{{ props.value }}条/页</span>
        </template>
      </a-pagination>
    </div>
    <a-modal
      :footer="null"
        title="提示"
        v-model="form.visible">
      <lookBook-edit
        v-if="form.visible"
        :look-book-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </lookBook-edit>
    </a-modal>

    <a-drawer
      title="look book商品"
      placement="right"
      :closable="false"
      width="60%"
      :destroyOnClose="true"
      @close="()=>{goodsForm.visible = false}"
      :visible="goodsForm.visible"
    >
      <look-book-goods
        v-if="goodsForm.visible"
        :look-book-id="goodsForm.data.id">
      </look-book-goods>
    </a-drawer>
  </a-card>
</template>

<script>
import {
  _queryLookBooks,
  _deleteLookBook,
  _upLookBook,
  _downLookBook
} from '@/api/lookBookApi';
import {
  _queryLookBookTopics,
} from '@/api/lookBookTopicApi';
import LookBookEdit from './LookBookEdit.vue';

async function getLookBookList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryLookBooks({
    topicId: this.searchForm.data.topicId,
    name: this.searchForm.data.name,
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
  this.table.query.total = result.totalElements;
  this.table.loading = false;
}

function addLookBook() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editLookBook(lookBookId) {
  this.form.data.id = lookBookId;
  this.form.visible = true;
}

async function upLookBook(lookBookId) {
  this.$confirm({
    title: '是否上移？',
    content: '',
    onOk: async () => {
      await _upLookBook(lookBookId);
      this.$message.success('上移成功');
      this.getLookBookList();
    },
  });
}

async function downLookBook(lookBookId) {
  this.$confirm({
    title: '是否下移？',
    content: '',
    onOk: async () => {
      await _downLookBook(lookBookId);
      this.$message.success('下移成功');
      await this.getLookBookList();
    },
  });
}

function lookBookDetail(lookBookId) {
  this.$router.push(`/look-books/${lookBookId}/goods`);
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getLookBookList();
}

function handleSizeChange(current, pageSize) {
  this.table.query.page = current;
  this.table.query.size = pageSize;
  this.getLookBookList();
}

async function deleteLookBook(lookBookId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteLookBook(lookBookId);
      this.$message.success('删除成功');
      await this.getLookBookList();
    },
  });
}

export default {
  name: 'LookBookList',
  components: { LookBookEdit },
  data() {
    return {
      searchForm: {
        data: {
          topicId: '',
          name: '',
        },
      },
      topic: {
        data: [],
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      goodsForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 10,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getLookBookList,
    deleteLookBook,
    editLookBook,
    addLookBook,
    handleSizeChange,
    lookBookDetail,
    closeForm,
    downLookBook,
    upLookBook,
  },
  async created() {
    const result = await _queryLookBookTopics({});
    this.topic.data = result.content;
    await this.getLookBookList();
  },
};
</script>

<style scoped>
.pagination-class{
  margin-right:10px;
}
</style>
